import { STATUS_POTENTIAL_COLOR } from "./constants"
import "./style.scss"

const StatusIcon = ({ status }: $TSMigrationFixMe) => {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  const bgcolor = STATUS_POTENTIAL_COLOR[status] || "#000"

  return (
    <span
      style={{
        backgroundColor: bgcolor,
      }}
      className='status-icon'
    />
  )
}

export default StatusIcon
